module.exports = __webpack_public_path__ + "static/media/sud_add2.a409d3a0.png";